import { userCurrenciesState } from "../../../slices/userCurrenciesSlice"
import { CurrencyAccountType, isCompositeCurrency, searchCurrencyItem } from "./utils"
import { PaymentCurrency, CurrencyPart, UserPaymentCurrency } from "../../../constants/types"
import { CurrencyType } from "@brg/api"

interface IsCashEnough {
    paymentCurrency: PaymentCurrency
    userBalance: userCurrenciesState
}

// проверка одной валюты / части сложной валюты
const isInsufficientPart = (userCurrencies: UserPaymentCurrency[], part: CurrencyPart): boolean => {
    if (part.currencyType === CurrencyType.RUB) return false

    const currencySearch = { 
        currencyType: part.currencyType,
        // ZELANDFIX временная мера, скоро починим оплату стран
        countryId: "",
    }
    const userPaymentCurrency = searchCurrencyItem({ 
        accountType: CurrencyAccountType.user,
        currencies: userCurrencies, 
        search: currencySearch 
    }) as UserPaymentCurrency | undefined

    // если искомая валюта не найдена у пользователя или в списке валют - недостаточно средств
    if (!userPaymentCurrency) {
        return true
    }

    // если не указано количество валюты - недостаточно средств
    if (!userPaymentCurrency.amount || !part.amount) return true

    return part.amount > userPaymentCurrency.amount
}

// проверка простой / сложной валюты
export const isInsufficientFunds = (props: IsCashEnough) => {
    const {
        paymentCurrency,
        userBalance,
    } = props

    const userPaymentCurrencies = userBalance?.currencies
    if (!userPaymentCurrencies) return true

    // подсчет условия для сложных валют
    if (isCompositeCurrency(paymentCurrency)) {
        let isInsufficient = false
        paymentCurrency.parts.forEach((part: CurrencyPart) => {
            if (isInsufficientPart(userPaymentCurrencies, part)) isInsufficient = true
        })
        return isInsufficient
    }

    return isInsufficientPart(userPaymentCurrencies, paymentCurrency)
}
import { userCurrenciesState } from "../../../slices/userCurrenciesSlice"
import { CurrencyAccountType, isCompositeCurrency, searchCurrencyItem } from "./utils"
import { PaymentCurrency, CurrencyPart, UserPaymentCurrency } from "../../../constants/types"
import { CurrencyType } from "@brg/api"

interface IsCashEnough {
    paymentCurrency: PaymentCurrency
    userBalance: userCurrenciesState
}

// проверка одной валюты / части сложной валюты
const isInsufficientPart = (userCurrencies: UserPaymentCurrency[], part: CurrencyPart): boolean => {
    if (part.currencyType === CurrencyType.RUB) return false

    const currencySearch = { 
        currencyType: part.currencyType,
        // ZELANDFIX временная мера, скоро починим оплату стран
        countryId: "",
    }
    const userPaymentCurrency = searchCurrencyItem({ 
        accountType: CurrencyAccountType.user,
        currencies: userCurrencies, 
        search: currencySearch 
    }) as UserPaymentCurrency | undefined

    // если искомая валюта не найдена у пользователя или в списке валют - недостаточно средств
    if (!userPaymentCurrency) {
        return true
    }

    // если не указано количество валюты - недостаточно средств
    if (!userPaymentCurrency.amount || !part.amount) return true

    return part.amount > userPaymentCurrency.amount
}

// проверка простой / сложной валюты
export const isInsufficientFunds = (props: IsCashEnough) => {
    const {
        paymentCurrency,
        userBalance,
    } = props

    const userPaymentCurrencies = userBalance?.currencies
    if (!userPaymentCurrencies) return true

    // подсчет условия для сложных валют
    if (isCompositeCurrency(paymentCurrency)) {
        let isInsufficient = false
        paymentCurrency.parts.forEach((part: CurrencyPart) => {
            if (isInsufficientPart(userPaymentCurrencies, part)) isInsufficient = true
        })
        return isInsufficient
    }

    return isInsufficientPart(userPaymentCurrencies, paymentCurrency)
}
